import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { MobileMenu } from './MobileMenu/MobileMenu';
import { Logo } from './Logo/Logo';
import { Assortment } from './Navigation/Assortment/Assortment';
import { LoginButton } from './LoginButton/LoginButton';
import { ProfileButton } from './ProfileButton/ProfileButton';
import { ModalSignUpSignIn } from '../Modals/ModalSignUpSignIn/ModalSignUpSignIn';
import { CartIcon } from 'components/Shared/CartIcon';
import { FavoriteIcon } from 'components/Shared/FavoriteIcon';
import { CartModal } from 'components/CartDrawer/CartDrawer';
import { useAuth } from 'utils/hooks';
import { setAuthModalOpen } from '../../redux/user/userSlice';
import { setCartOpen } from '../../redux/menu/menuSlice';
import { selectCart } from '../../redux/menu/menuSelectors';
import { useTypedDispatch, useTypedSelector } from '../../redux/hooks';
import {
  StyledHeader,
  HeaderInner,
  HeaderLeft,
  HeaderCenter,
  HeaderRight,
  IconButton,
} from './Header.styled';

export const Header = () => {
  const mobileVersion = useMediaQuery({ query: '(max-width:767px)' });
  const dispatch = useTypedDispatch();
  const navigate = useNavigate();
  const { isLoggedIn, isAuthModalOpen } = useAuth();
  const isCartOpen = useTypedSelector(selectCart);

  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleOpenSignUpSignInModal = () => {
    dispatch(setAuthModalOpen(true));
    document.body.style.overflow = 'hidden';
  };
  const handleCloseSignUpSignInModal = () => {
    dispatch(setAuthModalOpen(false));
    document.body.style.overflow = 'unset';
  };
  const toggleCart = () => {
    dispatch(setCartOpen(!isCartOpen));
  };
  const handleFavorites = () => {
    if (isLoggedIn) {
      navigate('/favorites');
    } else {
      handleOpenSignUpSignInModal();
    }
  };

  return (
    <>
      <StyledHeader $scrolled={scrolled}>
        <HeaderInner $scrolled={scrolled}>
          {mobileVersion ? (
            <MobileMenu />
          ) : (
            <>
              <HeaderLeft>
                <Assortment />
              </HeaderLeft>

              <HeaderCenter>
                <Logo scrolled={scrolled} />
              </HeaderCenter>

              <HeaderRight>
                <IconButton type="button" onClick={toggleCart} aria-label="Кошик">
                  <CartIcon />
                  <CartModal toggleCart={toggleCart} isCartOpen={isCartOpen} />
                </IconButton>

                <IconButton
                  type="button"
                  onClick={handleFavorites}
                  aria-label="Обране"
                >
                  <FavoriteIcon
                    handleOpenSignUpSignInModal={handleOpenSignUpSignInModal}
                  />
                </IconButton>

                {isLoggedIn ? (
                  <ProfileButton />
                ) : (
                  <LoginButton
                    handleOpenSignUpSignInModal={handleOpenSignUpSignInModal}
                  />
                )}
              </HeaderRight>
            </>
          )}
        </HeaderInner>
      </StyledHeader>
      <ModalSignUpSignIn
        isModalSignUpSignInOpen={isAuthModalOpen}
        handleCloseSignUpSignInModal={handleCloseSignUpSignInModal}
      />
    </>
  );
};
